import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c79692e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1c79692e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79692e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c79692e')) {
      api.createRecord('1c79692e', component.options)
    } else {
      api.reload('1c79692e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c79692e&scoped=true&", function () {
      api.rerender('1c79692e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/components/tables-settings-table/index.vue"
export default component.exports